<template>
    <b-modal
      id="localauthoritymodal"
      :title="formModal.title"
      @hidden="resetModal"
      @ok="handleSubmit"
      ok-title="Submit"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit" novalidate>

        <b-form-group label="Name" label-for="name-input">
            <b-form-input id="name-input" v-model="form.name" :state="validateState('name')"></b-form-input>
        </b-form-group>

        <b-form-group label="Short Name" label-for="name_short-input">
            <b-form-input id="name_short-input" v-model="form.name_short"></b-form-input>
        </b-form-group>

        <b-form-group label="State" label-for="state-input">
            <b-form-select id="state-input" v-model="form.state_id" :options="stateOptions" :state="validateState('state_id')" @change="onStateChange()"></b-form-select>
        </b-form-group>

        <b-form-group label="City" label-for="city-input">
            <b-form-select id="city-input" v-model="form.city_id" :options="cityOptions" :disabled="!form.state_id || loadingCities"></b-form-select>
            <small v-if="loadingCities" class="text-muted"><i class="las la-spinner la-spin"></i> Loading...</small>
            <small v-else-if="form.city_id === null && sourceCityName" class="d-block text-muted mt-1">
                Source data listed city as: {{ sourceCityName }}
            </small>
        </b-form-group>

        <b-form-group v-if="form.pbt_code" label="PBT Code">
            <b-form-input :value="form.pbt_code" disabled></b-form-input>
        </b-form-group>

      </form>
    </b-modal>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
    data(){
        return this.initData();
    },
    mounted() {
        this.loadStates();
    },
    validations: {
        form: {
            name: { required },
            state_id: { required },
        }
    },
    methods: {
        initData(){
            return {
                form:{
                    id: null,
                    name: null,
                    name_short: null,
                    state_id: null,
                    city_id: null,
                    pbt_code: null,
                    source_city_name: null,
                },
                formModal:{
                    title: null
                },
                isEdit: false,
                states: [],
                cities: [],
                loadingCities: false,
            }
        },
        validateState(name) {
            const { $dirty, $error } = this.$v.form[name];
            return $dirty ? !$error : null;
        },
        async loadStates() {
            try {
                const { data } = await axios.get(route("locations.states"));
                this.states = data;
            } catch (e) {
                console.log(e);
            }
        },
        async loadCities(stateId) {
            if (!stateId) {
                this.cities = [];
                return;
            }
            this.loadingCities = true;
            try {
                const { data } = await axios.get(route("locations.cities"), {
                    params: { state_id: stateId }
                });
                this.cities = data;
            } catch (e) {
                console.log(e);
            } finally {
                this.loadingCities = false;
            }
        },
        onStateChange(resetCity = true) {
            if (resetCity) {
                this.form.city_id = null;
            }
            this.loadCities(this.form.state_id);
        },
        openModal(){
            this.isEdit = false;
            this.formModal.title = "Add Local Authority";
            this.$bvModal.show('localauthoritymodal');
        },
        async editModal(id){
            this.isEdit = true;
            this.formModal.title = "Edit Local Authority";
            try {
                const { data } = await axios.get(route("admin.local-authorities.show", id));
                this.form = data;
                await this.loadCities(this.form.state_id);
                this.$bvModal.show('localauthoritymodal');
            } catch (e) {
                console.log(e);
                this.$swal('Error!', '', 'error');
            }
        },
        resetModal(){
            this.form = this.initData().form;
            this.cities = [];
            this.$nextTick(() => {
                this.$v.$reset();
            });
        },
        handleSubmit(bvModalEvt){
            bvModalEvt.preventDefault();
            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
                return;
            }
            if(this.isEdit == true){
                this.submitUpdate();
            }else{
                this.submitSave();
            }
        },
        async submitSave(){
            try {
                const { data } = await axios.post(route("admin.local-authorities.store"), {
                    form: this.form
                });
                this.$swal('Saved!', '', 'success');
                this.$bvModal.hide('localauthoritymodal');
                reloadTable();
            } catch (e) {
                console.log(e);
                this.$swal('Error!', '', 'error');
            }
        },
        async submitUpdate(){
            try {
                const { data } = await axios.put(route("admin.local-authorities.update", this.form.id), {
                    form: this.form
                });
                this.$swal('Saved!', '', 'success');
                this.$bvModal.hide('localauthoritymodal');
                reloadTable();
            } catch (e) {
                console.log(e);
                this.$swal('Error!', '', 'error');
            }
        },
        async deleteUser(id){
             this.$swal({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const { data } = await axios.delete(route("admin.local-authorities.destroy", id ));
                        this.$swal({
                            title: 'Deleted!',
                            text: 'Local Authority has been deleted.',
                            icon: 'success',
                            didClose: () =>{
                                reloadTable();
                            }
                        })
                    } catch (e) {
                        console.log(e);
                    }
                }
            });
        },
    },
    computed: {
        stateOptions() {
            return [{ value: null, text: 'Please select' }].concat(
                this.states.map(s => ({ value: s.id, text: s.name }))
            );
        },
        cityOptions() {
            return [{ value: null, text: 'None' }].concat(
                this.cities.map(c => ({ value: c.id, text: c.name }))
            );
        },
        sourceCityName() {
            return this.form.source_city_name;
        }
    }
}
</script>
